/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRoleSearchResult } from './APIRoleSearchResult';
import {
    APIRoleSearchResultFromJSON,
    APIRoleSearchResultFromJSONTyped,
    APIRoleSearchResultToJSON,
} from './APIRoleSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIRoleSearchResponse
 */
export interface APIRoleSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIRoleSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIRoleSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIRoleSearchResult>}
     * @memberof APIRoleSearchResponse
     */
    results: Array<APIRoleSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIRoleSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIRoleSearchResponse interface.
 */
export function instanceOfAPIRoleSearchResponse(value: object): value is APIRoleSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIRoleSearchResponseFromJSON(json: any): APIRoleSearchResponse {
    return APIRoleSearchResponseFromJSONTyped(json, false);
}

export function APIRoleSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRoleSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIRoleSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIRoleSearchResponseToJSON(value?: APIRoleSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIRoleSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

